import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/articles";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-28 border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.22em] text-primary-700">
              <span className="inline-block h-2 w-2 rounded-full bg-accent-500"></span>
              FAQ
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于内容来源、榜单算法、投稿与订阅，这里整理了读者最常问的几个问题。
            </p>
            <div className="mt-6 rounded-lg bg-secondary-100/70 p-5">
              <p className="text-sm text-secondary-900">没找到想问的问题？</p>
              <Link
                to="/contact"
                className="mt-3 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-700"
              >
                <i className="ri-chat-3-line" aria-hidden="true"></i>
                联系我们
              </Link>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((item, index) => {
                const isOpen = open === index;
                return (
                  <div key={item.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                      >
                        <span className="font-heading text-base font-bold text-foreground-950">
                          {item.q}
                        </span>
                        <i
                          className={
                            isOpen
                              ? "ri-subtract-line flex-shrink-0 text-xl text-primary-600"
                              : "ri-add-line flex-shrink-0 text-xl text-primary-600"
                          }
                          aria-hidden="true"
                        ></i>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">
                        {item.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}